<script>
export default {
  methods: {
    hasCts (type) {
      const hasCst = ['icms', 'ipi', 'pis', 'cofins', 'ibs', 'cbs'];

      return hasCst.includes(type);
    }
  }
};
</script>
